var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center p-l-0 p-r-0"},[_c('div',{staticClass:"progress-circle-indeterminate progress-circle-primary m-t-10"}),_c('br'),(_vm.with_text)?_c('p',{class:'small ' + _vm.text_class,domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }